import VoiceChatStatusBadge from 'components/badge/VoiceChatStatusBadge';
import { DivConst } from 'constants/divConst';

import type { VoiceChatResponseType } from 'types/api/voiceChatResponseType';
import { formatTimeToDate } from 'utils/app';
import { handleScrollToPopupEmbed } from 'utils/content';
import { formatPublishTerm } from 'utils/form';
import {
  getPreviewUrl,
  getProductionUrl,
  openPreviewUrl,
  openProductionUrl,
} from 'utils/voiceChat';

import type { JSX } from 'react';

/**
 * ボイスチャット作成編集 状態表示コンポーネント（WsFormEditStatusInfo ミラー）。
 * LINE 連携は実DBに存在しないため form のような分岐は持たない。
 */
export default function WsVoiceChatEditStatusInfo(props: {
  voiceChat: VoiceChatResponseType | null;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * 公開情報の表示可否を返します。
   */
  const _isVisiblePublishInfo = (): boolean => {
    if (!props.voiceChat) {
      return false;
    }
    if (props.voiceChat.voiceChatStatusDiv === DivConst.items.voiceChatStatus.reserved.value) {
      return true;
    }
    return props.voiceChat.publishedAt != null;
  };

  /**
   * ポップアップ埋め込みタグの表示可否を返します。
   */
  const _isVisiblePopupEmbed = (): boolean => {
    if (!props.voiceChat?.popupImageKey) {
      return false;
    }
    return _isVisiblePublishInfo();
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {props.voiceChat && (
        <div className="section-header user-detail">
          <div className="card-detail">
            <ul className="list-unstyled list-inline">
              <li className="list-inline-item">
                <b>ボイスチャット作成日</b>：
                {formatTimeToDate(props.voiceChat.createdAt, 'yyyy/MM/dd')}
              </li>
              <li className="list-inline-item">
                <VoiceChatStatusBadge voiceChatStatusDiv={props.voiceChat.voiceChatStatusDiv} />
              </li>
              {_isVisiblePublishInfo() && (
                <>
                  <li className="list-inline-item">
                    <b>公開期間</b>：
                    {formatPublishTerm({
                      formStatusDiv: props.voiceChat.voiceChatStatusDiv,
                      publishStartAt: props.voiceChat.publishStartAt,
                      publishEndAt: props.voiceChat.publishEndAt,
                      publishedAt: props.voiceChat.publishedAt,
                      terminatedAt: props.voiceChat.terminatedAt,
                    })}
                  </li>
                  <li className="list-inline-item">
                    <b>検索エンジン</b>：
                    <a>
                      {props.voiceChat.noIndexFlag && (
                        <span className="text-danger">インデックス対象外</span>
                      )}
                      {!props.voiceChat.noIndexFlag && <span>インデックス対象</span>}
                    </a>
                  </li>
                </>
              )}
            </ul>
            {_isVisiblePublishInfo() && (
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">
                  <b>公開URL</b>：
                  {props.voiceChat.voiceChatStatusDiv ===
                  DivConst.items.voiceChatStatus.published.value ? (
                    <a
                      className="form-profile"
                      onClick={() => openProductionUrl(props.voiceChat!.cd)}
                    >
                      {getProductionUrl(props.voiceChat.cd)}
                    </a>
                  ) : (
                    <span> {getProductionUrl(props.voiceChat.cd)}</span>
                  )}
                </li>
                <li className="list-inline-item">
                  <b>プレビューURL</b>：
                  <a
                    className="form-profile"
                    onClick={() => openPreviewUrl(props.voiceChat!.previewCd)}
                  >
                    {getPreviewUrl(props.voiceChat.previewCd)}
                  </a>
                </li>
              </ul>
            )}
            {_isVisiblePopupEmbed() && (
              <ul className="list-unstyled list-inline mt-2">
                <li className="list-inline-item">
                  <a href="#popup-embed" onClick={handleScrollToPopupEmbed}>
                    ポップアップ埋め込みタグ
                  </a>
                </li>
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
}
